import React from "react";
import {
  BannerWrapper,
  Container,
  ContentBottom,
  HintScroll,
  PialaByuImg,
  ScrollDownIcon,
  TitleImg,
} from "./BannerPressCon.styled";
import { Container as ContainerGrid, Row, Col } from "react-grid-system";

import { func } from "../../../../utils";
import _function, { getStaticImg, scrollTo } from "../../../../utils/function";
import useWindowSize from "../../../../hooks/useWindowSize";
// import LiveBanner from "../../../atoms/LiveBanner";
import LiveBannerNew from "../../../atoms/LiveBannerNew";
import { Box, ContainerHeadline, Headline } from "../BannerCity/BannerCity.styled";
import { Button, Text } from "../../../atoms";
import Card from "../../../atoms/NewCard";
import { JadwalKlasemenContainer } from "../../../../pages/v2/HomeDetails/HomeDetails.styled";
import { usePageContextState } from "../../../../context/PageContext";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { useScrollIntoView } from "../../../atoms/Tabs/utils";

const BannerPressCon = ({ data, slug, children }) => {
  const { isLive } = usePageContextState();
  const event_start_date = data?.event_start_date;
  const event_end_date = data?.event_end_date;
  const currentDate = moment().format("YYYY-MM-DD");

  const isOnGoingEvent =
    event_start_date &&
    event_end_date &&
    currentDate >= moment(event_start_date).format("YYYY-MM-DD") &&
    currentDate <= moment(event_end_date).format("YYYY-MM-DD");

  const isSameMonthEvent =
    moment(event_start_date).format("MMMM") === moment(event_end_date).format("MMMM");
  const isSameDayEvent =
    moment(event_start_date).format("D") === moment(event_end_date).format("D");
  const isSameYearEvent =
    moment(event_start_date).format("YYYY") === moment(event_end_date).format("YYYY");
  const labelStartEvent = moment(event_start_date).format(
    isSameMonthEvent ? "D" : isSameYearEvent ? "DD MMMM" : "DD MMMM YYYY",
  );
  const eventDate = `${isSameDayEvent ? "" : labelStartEvent + " -"} ${moment(
    event_end_date,
  )?.format("D MMMM YYYY")}`;

  const loc = data?.location || "-";
  const city = data?.location?.includes("UNJ") ? "JAKARTA" : String(data?.city)?.toUpperCase();
  // const city = data?.city ? String(data?.city)?.toUpperCase() : "-";

  const navigate = useNavigate();
  const { size } = useWindowSize();

  const isSmallScreen = (size?.height || 0) <= 667;
  const isExtraSmallScreen = (size?.width || 0) <= 375 && (size?.height || 0) <= 600;
  const isMobileView = (size?.width || 0) <= 830;
  const handleScroll = () => {
    _function.scrollTo("guest-star");
  };

  const MobileBanner = () => {
    return (
      <div className="relative">
        <div className="absolute top-[70vh] left-0 right-0  flex justify-center">
          {/* <img
            className={"w-[275px]"}
            src={getStaticImg("bg/btn-banner-presscon-m.png")}
            alt="button"
            onClick={() => {
              navigate("/registrasi");
            }}
          /> */}
          <img
            className="w-[80vw] cursor-pointer"
            src={getStaticImg("bg/btn-banner-presscon.png")}
            alt="button"
            onClick={() => {
              scrollTo("banner-section2");
            }}
          />
          {/* <Button
            style={{
              background: "linear-gradient(90deg, #00BCF1 0%, #006C8B 100%)",
              filter: "blur(5px)",
            }}
            variant={"dark"}
            size={"small"}
            className={"w-[262px] h-[52px]"}
          >
            <span className="font-bold text-[16px]">Daftar Sekarang</span>
          </Button> */}
        </div>
        {/* <div className="absolute top-[67svh] left-0 right-0  flex justify-center z-10">
          <Button
            variant={"dark"}
            size={"small"}
            className={" w-[249px] h-[45px]"}
            onClick={() => {
              navigate("/rsvp");
            }}
          >
            <span className="font-bold text-[16px]">Daftar Sekarang</span>
          </Button>
        </div> */}
      </div>
    );
  };

  const DesktopBanner = () => {
    return (
      <>
        <Row style={{ maxWidth: "1440px", alignSelf: "center" }}>
          <Col md={4}>
            {/* <PialaByuImg
              margin={"auto"}
              src={func.getStaticImg("illustration/conference/kv-desktop.png")}
              maxHeight={"max-content"}
            />
            <img
              className="absolute -bottom-10 m-auto left-0 right-0"
              src={func.getStaticImg("illustration/soc-title.svg")}
              alt="kv-title"
            /> */}
          </Col>
          <Col
            md={7}
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <div className="mt-[70vh] cursor-pointer" style={{ justifyContent: "center" }}>
              <Container margin="-2vw 0 0 0">
                <img
                  className="w-[80vw] ml-[5vw] cursor-pointer"
                  src={getStaticImg("bg/btn-banner-presscon.png")}
                  alt="button"
                  onClick={() => {
                    scrollTo("banner-section2");
                  }}
                />
              </Container>
            </div>
          </Col>
        </Row>
      </>
    );
  };

  const Content = () => (isMobileView ? <MobileBanner /> : <DesktopBanner />);
  const backdropBanner = isMobileView
    ? func.getStaticImg("bg/banner-presscon-m.png")
    : func.getStaticImg("bg/banner-presscon-d.png");
  const backdropStyles = isMobileView
    ? {
        height: "90svh",
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        backgroundSize: "auto 75vh",
      }
    : {
        height: "100vh",
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      };
  return (
    <div className="">
      <BannerWrapper
        id="banner"
        backgroundSize={"contain"}
        backgroundImage={backdropBanner}
        backgroundPosition={!isMobileView ? "top" : "center 0px"}
        {...backdropStyles}
      >
        <Content />
      </BannerWrapper>
    </div>
  );
};

export default BannerPressCon;
